import React, { Fragment, memo, useCallback } from "react";
import * as Common from "bodycodi/cmap/app/js/common";
import Dialog from "@material-ui/core/Dialog";
import "bodycodi/cmap/app/css/common/alert2.css";

const CustomAlertWithReasons = ({ open, setOpen, header, body, cancelAlert, closeAlert }) => {
  const handleClose = () => {
    setOpen(false);
    if (!Common.isEmpty(closeAlert)) {
      closeAlert();
    }
  };

  const handleCancel = () => {
    if (!Common.isEmpty(cancelAlert)) {
      cancelAlert();
    }
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} className="alert-pop" classes={{ paper: "alert" }}>
      <div className="alert-header">
        <span>{header}</span>
      </div>
      <div className="alert-header-bar"></div>

      <div className={"alert-body reasons"}>
        <p>{`다음과 같은 사유로 \n앱 결제 요청을 할 수 없어요.`}</p>

        <div className="reason-list">
          {body?.map((reason, index) => {
            return (
              <div key={index} className="one-reason">
                <span className="middot">&#183;</span>
                <p className="reason-text">{reason}</p>
              </div>
            );
          })}
        </div>

        <p className="footer-text">{`자세한 내용은 바디코디 회원관리프로그램에서 \n확인해 주세요!`}</p>
      </div>

      <div className="alert-footer">
        <div className="alert-footer-half-button black" onClick={handleCancel}>
          취소
        </div>
        <div className={"alert-footer-half-button blue"} onClick={handleClose}>
          확인
        </div>
      </div>
    </Dialog>
  );
};

export default memo(CustomAlertWithReasons);
